export const CAN_LOGIN = "CAN.LOGIN";

export const ADMIN_PRODUCT = "PRODUCT.ADMIN";
export const ADMIN_BILLING = "BILLING.ADMIN";
export const VIEW_SETTINGS = "VIEW.SETTINGS";
export const EDIT_INSTANCE = "EDIT.INSTANCE";

export const SUPER_ADMIN = "licensee.admin.super";
export const SUPER_ADMIN_VIEW = "licensee.admin.view";
export const SUPER_ADMIN_MANAGE_ALLOCATIONS = "licensee.admin.manage_allocations";
export const SUPER_ADMIN_MANAGE_ENTITLEMENTS = "licensee.admin.manage_entitlements";
export const SUPER_ADMIN_GRANT_OUT_OF_SYNC = "licensee.admin.grant_out_of_sync";
export const SUPER_ADMIN_VERIFY_SYNC = "licensee.admin.verify_sync";
export const SUPER_ADMIN_REPAIR_SYNC = "licensee.admin.repair_sync";
export const SUPER_ADMIN_VIEW_BILLING = "licensee.admin.view_billing";
export const SUPER_ADMIN_MANAGE_BILLING = "licensee.admin.manage_billing";
export const SUPER_ADMIN_PROCESS_PAYMENTS = "licensee.admin.process_payments";
export const SUPER_ADMIN_APPLY_DISCOUNTS = "licensee.admin.apply_discounts";
export const SUPER_ADMIN_VIEW_AUDIT = "licensee.admin.view_audit";

export const canViewSuperAdmin = (permissions = []) =>
    permissions.includes(SUPER_ADMIN) && permissions.includes(SUPER_ADMIN_VIEW);

export const canSuperAdmin = (permissions = [], permission) =>
    permissions.includes(SUPER_ADMIN) && permissions.includes(permission);

export const canViewFeradelAdministration = (permissions = []) =>
    permissions.includes(VIEW_SETTINGS);

export const canManageFeradelAdministration = (permissions = []) =>
    permissions.includes(VIEW_SETTINGS) && permissions.includes(ADMIN_PRODUCT);
